<h2 mat-dialog-title>
  <span>{{title}}</span>
  <span class="icon-close icon-Cross" mat-dialog-close></span>
</h2>
<mat-dialog-content>
  <div class="dialog-content">
    <p *ngIf="!!subtitle" class="subtitle" [innerHTML]="subtitle"></p>
    <p *ngIf="!!message" [innerHTML]="message"></p>
    <span *ngIf="!!caption" class="caption" [innerHTML]="caption"></span>
  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="!!closeButton" class="btn-main btn-secondary-purple btn-xl" mat-dialog-close>
    {{ closeButton }}
  </button>
  <button *ngIf="!!confirmButton" class="btn-main btn-primary btn-xl" (click)="confirm()">
    {{ confirmButton }}
  </button>
</mat-dialog-actions>
